import React from 'react';
import { Crown, ArrowRight, TrendingUp, Users, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function LeadershipPage() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-952" data-mp="1qjiz2l95jka1">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-953" data-mp="1zlih9gvwkuek">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-954" data-mp="2eaofp2mx2gle" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-955" data-mp="29b21apvcqub0">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-956" data-mp="sxlp5c8u8n9p">
            Executive Recruiting
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-957" data-mp="3cmo8qbnew3gb">
            HIRE Leadership
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-958" data-mp="3hlr4t6leyzc5">
            For companies that need to recruit leadership-level talent to scale
            their D2D and home services operation.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-959" data-mp="3vcnuopnyh2fi">
            Finding managers and team leaders requires a different approach. We
            build and run targeted campaigns to attract the leaders who will
            drive your team's growth.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-960" data-mp="e3r3ube9zu81">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-961" data-mp="2axu78mfkxzzw">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-962" data-mp="2fwx59mx575yd">
            <div className="mb-4" data-id="element-963" data-mp="27vz7fj8vn4q8">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-964" data-mp="27xaebrxmcslk">
                Build and Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-965" data-mp="2huf3m0mrh46l">$1,000*</div>
              <p className="mt-2 text-xs text-slate-500" data-id="element-966" data-mp="2ctrcleyj8ncd">
                *Must be built in conjunction with a standard campaign.
              </p>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-967" data-mp="2qs8vmzdhtbny">
                {['Leadership opportunity and company profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and leadership-focused ad copywriting', 'Landing pages and executive application flows', 'Targeted campaign design built to reach experienced operators', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Covers build and implementation of standard and leadership campaign'].map((point, i) => <li key={i} className="flex items-start" data-id="element-968" data-mp="3t3z5iu051a29" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-969" data-mp="3f5si67stesgu" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-970" data-mp="3k4lqzmx5pvao">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-971" data-mp="2wg2o5mwvmapz">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-972" data-mp="30hnv6rmqbus9" />
            <div className="mb-4" data-id="element-973" data-mp="30fbesiwmdshb">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-974" data-mp="2mhmtxb2jylc9">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-975" data-mp="2rggaxdh1suh6">$2,500</div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-976" data-mp="3ttch6b8mh67z">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-977" data-mp="3psaetljese1s">
                <div className="flex justify-between text-sm" data-id="element-978" data-mp="3pv6g9jugtkuz">
                  <span className="text-slate-400" data-id="element-979" data-mp="3l0ix80i8dins">Campaign Management</span>
                  <span className="text-white font-medium" data-id="element-980" data-mp="3g1xxe26w50zv">$2,500</span>
                </div>
              </div>

              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-981" data-mp="3b4pbprmjaetv">
                {['Active ad management and real-time optimization', 'Targeted outreach to experienced operators and team leaders', 'Interview execution handled for you', 'Vetted candidates passed to you for final approval only', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-982" data-mp="ve36lccr9nfh" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-983" data-mp="12wkh9lwdb8a1" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-984" data-mp="17vdwbiraz7cb">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Performance Pricing */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-985" data-mp="1hknsb9p9pa5p">
            <div className="mb-4" data-id="element-986" data-mp="jyqdbma3jmyi">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-987" data-mp="jzj8rr3luq1c">
                Performance Pricing
              </div>
              <div className="flex items-baseline mb-2" data-id="element-988" data-mp="tvcx07qos7yy">
                <span className="text-3xl font-bold text-white" data-id="element-989" data-mp="txz4669o0lgn">2.5%</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-990" data-mp="xyrdezijeqcx">of revenue</span>
              </div>
              <p className="text-sm text-slate-400 mb-4" data-id="element-991" data-mp="25a88xlxy7vbt">Capped at $15,000</p>
              <div className="bg-slate-900/60 border border-slate-700/50 rounded-lg p-3" data-id="element-992" data-mp="29bbr4f3gy3g7">
                <p className="text-xs text-slate-400 flex items-start leading-relaxed" data-id="element-993" data-mp="a6trhrys8vq6">
                  <ArrowRight className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-994" data-mp="591pu68c5v8s" />
                  <span data-id="element-995" data-mp="j81h7ln8go8n">
                    Based on the leader's{' '}
                    <strong className="text-slate-200" data-id="element-996" data-mp="j5xdb3pc3p8d">
                      personal and team
                    </strong>{' '}
                    production combined.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-997" data-mp="3ip9gc8ntwqqi">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-998" data-mp="bibl6bn1igu">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 3. WHO LEADERSHIP IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-999" data-mp="2z07cqkcdt72j">
        <div className="text-center mb-12" data-id="element-1000" data-mp="1eh4yrj545nbm">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-1001" data-mp="1eg3npeo3l0tw">
            Why Leadership Recruiting Is Different
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-1002" data-mp="15gp0co3896dm">
            Recruiting managers and team leaders requires a different approach
            than recruiting reps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1003" data-mp="1y5nivmb9iajg">
          <div className="space-y-4 text-slate-400" data-id="element-1004" data-mp="1y3jhpc4qzpmv">
            <p data-id="element-1005" data-mp="225xvhhtk7z7a">
              Leadership-level talent doesn't respond to mass recruiting
              funnels. They aren't looking, so they need to be found.
            </p>
            <p data-id="element-1006" data-mp="1t5rngbgmrrfi">
              We build dedicated campaigns designed to attract operators who can
              run teams, drive culture, and own production at scale.
            </p>
            <p data-id="element-1007" data-mp="hr4armckjavd">
              Because the impact of one strong leader compounds, the pricing is
              aligned to outcomes, not activity.
            </p>
          </div>
          <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 space-y-6" data-id="element-1008" data-mp="19cmb5wo4ti9u">
            <div className="flex items-start" data-id="element-1009" data-mp="14hp3at2l9eyj">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1010" data-mp="zfpzji2xsg12">
                <Users className="w-6 h-6 text-[#7FE0C3]" data-id="element-1011" data-mp="ujj4ikc2woxw" />
              </div>
              <div data-id="element-1012" data-mp="1s4nilnez2guv">
                <h3 className="text-white font-bold mb-2" data-id="element-1013" data-mp="1s79lh9qx486r">
                  Interviews Handled
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-1014" data-mp="1ifdndyou0i2j">
                  We run the interview process and only pass candidates to you
                  for final approval, so leadership time stays focused on
                  production.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1015" data-mp="2axixfbcibebn">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1016" data-mp="263wu49s8gmsi">
                <TrendingUp className="w-6 h-6 text-[#7FE0C3]" data-id="element-1017" data-mp="2if7ezmq3286j" />
              </div>
              <div data-id="element-1018" data-mp="2iha3u3fi1v9o">
                <h3 className="text-white font-bold mb-2" data-id="element-1019" data-mp="2neaaafg9h01b">
                  Performance Aligned
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-1020" data-mp="2sdwoos7tsmbp">
                  You only pay more when the leader's team actually produces.
                  Performance pricing kicks in at production milestones, not at
                  hire.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1021" data-mp="3649twmtc1mxc">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1022" data-mp="365bfhl7z5rtb">
                <Crown className="w-6 h-6 text-[#7FE0C3]" data-id="element-1023" data-mp="3g3hjc8dcd80t" />
              </div>
              <div data-id="element-1024" data-mp="3l227h9fbk18w">
                <h3 className="text-white font-bold mb-2" data-id="element-1025" data-mp="3l1j02mnaov94">Targeted Outreach</h3>
                <p className="text-slate-400 text-sm" data-id="element-1026" data-mp="15n8nav10t1sk">
                  Campaigns are built to attract experienced operators, not
                  generic applicants.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-1027" data-mp="1em3pzx4uvtr4">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-1028" data-mp="1jgq62dlvuahj">
          Ready to recruit leaders who scale your team?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-1029" data-mp="1tcba0haihktx">
          Discuss Leadership
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-1030" data-mp="22drbfzjcmcm0" />
        </button>
      </section>
    </div>;
}